import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../instance";
import { baseURLRef } from "../../utils";

const initialState = {
  authLoading: false,
  user: {},
  isActive: false,
  refresh_token: "",
  authData: {},
  saving: false,

  forgotAcc: {},
  singleUser: {},
  loginInfo: {},
  accountInfo: {},
  userOut: {},

  data: {},
  count: {},
  loading: false,
};
export const fetchData = createAsyncThunk(
  "fetch/fetchData",
  async (data, { rejectWithValue }) => {
    const { url, ...body } = data;

    await new Promise((resolve) => setTimeout(resolve, 0));

    try {
      const response = await axios({
        url: `${baseURLRef.current}/${url}`,
        method: "POST",
        data: Object.keys(body).length ? body : null,
      });
      if (!response.data.success) {
        return {
          key: url,
          data: [],
          total: 0,
        };
      }

      return {
        key: url,
        data: response?.data?.data?.result,
        total: response?.data?.total,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const loginIntial = createAsyncThunk(
  "authSlice/loginIntial",
  async (data, { rejectWithValue }) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 0));
      const response = await axios.post(
        `${baseURLRef.current}/auth/login`,
        data
      );
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const login = createAsyncThunk(
  "authSlice/login",
  async (data, { rejectWithValue }) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 0));
      const response = await axios.post(
        `${baseURLRef.current}/auth/login`,
        data,
        {
          withCredentials: true,
        }
      );
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const save = createAsyncThunk(
  "user/save",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      await new Promise((resolve) => setTimeout(resolve, 0));
      const response = await axios.post(
        `${baseURLRef.current}/${saveUrl}`,
        data
      );
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      await new Promise((resolve) => setTimeout(resolve, 0));
      const response = await axios.post(
        `${baseURLRef.current}/${saveUrl}`,
        data
      );
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveOtp = createAsyncThunk(
  "saveSlice/saveOtp",
  async (data, { rejectWithValue }) => {
    let saveUrl = data.url;
    delete data.url;
    try {
      await new Promise((resolve) => setTimeout(resolve, 0));
      const response = await axios.post(
        `${baseURLRef.current}/${saveUrl}`,
        data
      );
      if (!response.data.success) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = {};
      state.isActive = false;
      state.refresh_token = "";
      state.chooseAccount = false;
      state.authData = {};
      state.userOut = {};
      state.accountInfo = {};
    },
    handleLoginSession: (state, action) => {
      state.isActive = action.payload;
    },
    handleUserRefreshToken: (state, action) => {
      state.refresh_token = action.payload;
    },

    handleUser: (state, action) => {
      state.user = action.payload;
    },
    handleAuthData: (state, action) => {
      state.authData = { ...state.authData, ...action.payload };
    },

    handleUserOut: (state, action) => {
      state.userOut = action.payload;
    },
    setAccInfo: (state, action) => {
      state.accountInfo = action.payload;
    },
    cleanForgotAcc: (state, action) => {
      state.forgotAcc = initialState.forgotAcc;
    },
    cleanSingleUser: (state) => {
      state.singleUser = initialState.singleUser;
    },
    cleanAuthLoading: (state) => {
      state.authLoading = initialState.authLoading;
    },
    clearAuthObj: () => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        const { key, data, total } = action.payload;

        if (!state.data) state.data = {};
        if (!state.count) state.count = {};

        state.data = { ...state.data, [key]: data || [] };
        state.count = { ...state.count, [key]: total || 0 };
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        const key = action.payload?.key || "unknown";

        if (!state.data) state.data = {};
        if (!state.count) state.count = {};

        state.data = { ...state.data, [key]: [] };
        state.count = { ...state.count, [key]: 0 };
      })

      .addCase(loginIntial.pending, (state) => {
        state.authLoading = true;
      })
      .addCase(loginIntial.fulfilled, (state, action) => {
        state.authLoading = false;
        state.loginInfo = action.payload?.data?.result;
      })
      .addCase(loginIntial.rejected, (state) => {
        state.authLoading = false;
        state.loginInfo = {};
      })

      .addCase(login.pending, (state) => {
        state.authLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.authLoading = false;
      })
      .addCase(login.rejected, (state) => {
        state.authLoading = false;
      })

      .addCase(save.pending, (state) => {
        state.saving = true;
      })
      .addCase(save.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(save.rejected, (state) => {
        state.saving = false;
      })

      .addCase(resetPassword.pending, (state) => {
        state.saving = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.saving = false;
        state.forgotAcc = action.payload?.data?.result;
      })
      .addCase(resetPassword.rejected, (state) => {
        state.saving = false;
      })

      .addCase(saveOtp.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveOtp.fulfilled, (state, action) => {
        state.saving = false;
      })
      .addCase(saveOtp.rejected, (state) => {
        state.saving = false;
      });
  },
});

export default authSlice.reducer;
export const {
  logout,
  setAuth,
  handleUserRefreshToken,
  handleChooseAccount,
  handleLoginSession,
  handleUser,
  handleAuthData,
  setAccInfo,
  cleanSingleUser,
  cleanForgotAcc,
  handleUserOut,
  cleanAuthLoading,
  clearAuthObj,
} = authSlice.actions;
